import React, { Fragment } from 'react'
import classNames from 'classnames'

import Link from './link'
import Dropdown from './dropdown'

import classes from '../styles/nav.module.sass'

const DropdownNavigation = ({ items, defaultValue = '0' }) => {
    return (
        <div className={classes.dropdown}>
            <Dropdown className={classes.dropdownSelect} defaultValue={defaultValue}>
                <option value="0" disabled>
                    Navigation
                </option>
                {items.map(({ text, url, menu }, i) => {
                    const menuContent = menu ? [...(menu.main || []), ...(menu.footer || [])] : []
                    const hasMenu = !!menuContent.length
                    return (
                        <Fragment key={i}>
                            <option value={url} key={text} disabled={hasMenu}>
                                {text}
                            </option>
                            {hasMenu &&
                                menuContent.map(sub => (
                                    <option value={sub.url} key={sub.text}>
                                        &nbsp;&nbsp;&nbsp;&rsaquo; {sub.text}
                                    </option>
                                ))}
                        </Fragment>
                    )
                })}
            </Dropdown>
        </div>
    )
}

export default ({ items = [], search, className }) => {
    return (
        <nav className={classNames(classes.root, className)}>
            <ul className={classes.list}>
                {items.map(({ text, url, blank, menu }) => {
                    const hasMenu = !!menu
                    const menuMain = hasMenu && menu.main
                    const menuFooter = hasMenu && menu.footer
                    const itemClassNames = classNames(classes.item, {
                        [classes.hasSub]: hasMenu,
                    })
                    return (
                        <li className={itemClassNames} key={text}>
                            <Link hidden to={url} target={blank ? '_blank' : null}>
                                {text}
                            </Link>
                            {hasMenu && (
                                <div className={classes.sub}>
                                    {menuMain && (
                                        <ul className={classes.subList}>
                                            {menuMain.map(({ text, label, url }, i) => (
                                                <li key={i}>
                                                    <Link
                                                        hidden
                                                        className={classes.subItem}
                                                        to={url}
                                                    >
                                                        <strong>{text}</strong>
                                                        <div className={classes.subMeta}>
                                                            {label}
                                                        </div>
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                    {menuFooter && (
                                        <ul className={classes.subFooter}>
                                            {menuFooter.map(({ text, label, url }, i) => (
                                                <li key={i}>
                                                    <Link
                                                        hidden
                                                        className={classes.subItem}
                                                        to={url}
                                                    >
                                                        <strong>{text}</strong>
                                                        <div className={classes.subMeta}>
                                                            {label}
                                                        </div>
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            )}
                        </li>
                    )
                })}
                {search && <li className={classNames(classes.item, classes.search)}>{search}</li>}
            </ul>
            <DropdownNavigation items={items} />
        </nav>
    )
}
